module.exports = __webpack_public_path__ + "static/media/codeRainbowBalls.e90f3199.jpg";